import { render, staticRenderFns } from "./TwProcessGroupListEditSimple.vue?vue&type=template&id=4888d42f&"
import script from "./TwProcessGroupListEditSimple.vue?vue&type=script&lang=js&"
export * from "./TwProcessGroupListEditSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports